import { Component } from '@angular/core';
import { LanguageService } from 'projects/common/src/app/services/parameters';

@Component({
  selector: 'app-no-data-message',
  templateUrl: './no-data-message.component.html',
  styleUrls: ['./no-data-message.component.scss'],
})
export class NoDataMessageComponent {
  public DEFAULT = 'the_request_did_not_find_results';

  constructor(private readonly languageService: LanguageService) {}

  public get displayText(): string {
    return this.languageService.message(this.DEFAULT);
  }
}
